import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import rating from "./slices/ratingSlice";
import report from "./slices/reportSlice";
import department from "./slices/departmentSlice";
import category from "./slices/categorySlice";
import employee from "./slices/employeeSlice";
import employeeTransfer from "./slices/employeeTransferSlice";
import userPermit from "./slices/userPermissionSlice";
import role from "./slices/rolePermitSlice";
import favoriteMenu from "./slices/favoriteMenuSlice";
import setting from "./slices/settingSlice";
import posts from "./slices/postsSlice";
import hospitalManagement from "./slices/hospitalManagementSlice";
import doctorManagement from "./slices/doctorManagementSlice";
import appointment from "./slices/appointmentSlice";
import notification from "./slices/notificationSlice";
import ambulance from "./slices/ambulanceSlice";
import comment from "./slices/commentSlice";
import bhytCategory from "./slices/bhxhCategorySlice";
import hrRecord from "./slices/hrRecordSlice";
import bangCong from "./slices/bangCongSlice";
import dichvutainhacategory from "./slices/dichVuTaiNhaCategorySlice";
import dichvutainha from "./slices/dichVuTaiNhaSlice";
import khachhang from "./slices/khachhangSlice";
import tuyenDung from "./slices/tuyenDungSlice";
import quanLyDuAn from "./slices/quanLyDuAnSlice";
import congvan from "./slices/quanLyCongVanSlice";
import sangKienYTuong from "./slices/sangKienYTuongSlice";
import qlCong from "./slices/qlCongSlice";
import qlNghi from "./slices/qlNghiSlice";
import ketquaCdha from "./slices/cdhaSlice";
//Contract Import
import contractTypes from "./slices/employmentContract/contractTypesSlice";
import contractSettings from "./slices/employmentContract/contractSettingsSlice";
import hrmContract from "./slices/employmentContract/hrmContractSlice";
import contract from "./slices/employmentContract/contractSlice";
import trinhDoHocVan from "./slices/trinhDoHocVanSlice";

//Training Import
import trainingMethods from "./slices/training/trainingMethodSlice";
import trainingCenters from "./slices/training/trainingCenterSlice";
import trainingExpenses from "./slices/training/trainingExpenseSlice";
import trainingPrograms from "./slices/training/trainingProgramSlice";
import trainingEmployees from "./slices/training/trainingEmployeeSlice";
import trainingCme from "./slices/training/trainingCmeSlice";

//Signature Import
import signatureProcess from "./slices/signatureProcessSlice";
import documentSettings from "./slices/common/documentSettingSlice";
//Overtime
import overTimes from "./slices/overtime/overTimeSlice";
//CongTacVien
import partners from "./slices/partner/partnerSlice";
// T?i ch?nh k? to?n
import dinhKhoanCategory from "./slices/finance/dinhKhoanCategorySlice";
import thuChiCategory from "./slices/finance/thuChiCategorySlice";
import deNghiChi from "./slices/finance/deNghiChiTienSlice";
import deNghiThuTien from "./slices/finance/deNghiThuTienSlice";
//MEAL ALOWWANCE
import mealAllowances from "./slices/mealAllowance/mealAllowanceSlice";
// Bang luong
import thietlapluong from "./slices/salary/thietLapLuongSlide";
import quanlyluong from "./slices/salary/quanLyLuongSlice";
import bangPhuCapGiamTru from "./slices/salary/quanLyPhuCapGiamTruSlice";
// Common
import attachment from "./slices/common/attachmentSlide";
import erpComment from "./slices/common/erpCommentSlice";
import erpImport from "./slices/common/erpImportTransactionSlice";
import regulationDocumentSetting from "./slices/regulation/regulationDocumentSettingSlice";
import historyChange from "./slices/common/hisTorychangeSlice";

import regulationManage from "./slices/regulation/regulationManageSlice";
import documentManage from "./slices/regulation/documentManageSlice";
import hoSoManage from "./slices/regulation/hoSoManageSlice";
import ghiNhanYeuCau from "./slices/ghiNhanYeuCau/ghiNhanYeuCauSlice";
import erpNotification from "./slices/common/erpNotificationSlice";

import ksk from "./slices/khamSucKhoeDoanSlice";
import crmExport from "./slices/crm/crmExportSlice";

import practiveManagement from "./slices/hrm/practivemanagementSlice";
import noidungchuyenmonthuchanhSlice from "./slices/hrm/dmnoidungchuyenmonthuchanhSlice";
import thietlapthuchanhSlice from "./slices/hrm/thietlapthuchanhSlice";
import xinThoiViecSlice from "./slices/hrm/xinThoiViecSlice";
//sale

import banHangSale from "./slices/sale/banhangSlice";
import baoCaoSale from "./slices/sale/baocaoSlice";
import danhMucSale from "./slices/sale/danhmucSlice";
import nhapKhoSale from "./slices/sale/nhapkhoSlice";
import settingSale from "./slices/sale/settingSlice";
import thuChiSale from "./slices/sale/thuchiSlice";
import traCuuSale from "./slices/sale/tracuuSlice";
import traHangSale from "./slices/sale/trahangSlice";
import uploadSale from "./slices/sale/uploadFileSlice";
import xuatKhoSale from "./slices/sale/xuatkhoSlice";
import nhapXuatSale from "./slices/sale/nhapxuatSlice";
import thuTienSale from "./slices/sale/thuchiSlice";
import deXuatMuaSam from "./slices/sale/dexuatmuasamSlice";
import tonghopdeXuatMuaSam from "./slices/sale/tonghopdexuatmuasamSlice";
import salechangehistory from "./slices/sale/salechangehistorySlice";
import kehoachmuahang from "./slices/sale/kehoachmuahangSlice";
import phieuChiTien from "./slices/finance/phieuChiTienSlice";
import phieuThuTien from "./slices/finance/phieuThuTienSlice";
import deNghiTamUng from "./slices/finance/deNghiTamUngSlice";
import chuyenNoiBo from "./slices/finance/chuyenNoiBoSlice";
import deXuatThanhToan from "./slices/finance/deXuatThanhToanSlice";
import chungTuNghiepVuKhac from "./slices/finance/chungTuNghiepVuKhacSlice";
import financeMuaBanHang from "./slices/sale/financeMuaBanHangSlice";

//Thi?t l?p kh?c

import chucVuCategory from "./slices/thietLapKhac/chucVuCategorySlice";
import chucDanhCategory from "./slices/thietLapKhac/chucDanhCategorySlice";
import chuyenMonCategory from "./slices/thietLapKhac/chuyenMonCategorySlice";
import hocVanCategory from "./slices/thietLapKhac/hocVanCategorySlice";
import thietLapKhac from "./slices/thietLapKhac/thietLapKhacSlice";

//T�i S?n

import nhomTaiSan from "./slices/asset/settings/nhomTaiSanSlice";
import loaiTaiSan from "./slices/asset/settings/loaiTaiSanSlice";
import taiXe from "./slices/asset/settings/taiXeSlice";
import taiSan from "./slices/asset/list/taiSanSlice";

import capPhatTaiSan from "./slices/asset/manage/capPhatSlice";
import thuHoiTaiSan from "./slices/asset/manage/thuHoiSlice";
import suaChua from "./slices/asset/suachua/suaChuaSlice";
import categoryAssetSlice from "./slices/asset/settings/categoryAssetSlice";
import linhKien from "./slices/asset/list/linhKienSlice";
import baoMat from "./slices/asset/baomat/baoMatSlice";
import assetDieuChuyen from "./slices/asset/dieuChuyenSlice";
import viTritaiSan from "./slices/asset/settings/viTritaiSanSlice";
import deXuatMuaSamTS from "./slices/asset/deXuatMuaSamSlice";
import banGiaoTaiSan from "./slices/asset/bangiao/banGiaoTaiSanSlice";
import dieuXe from './slices/asset/dieuxe/dieuXeSlice';


// Marketing campaign
import marketingCampaign from "./slices/crm/marketingCampaignSlide";
import marketingSetting from "./slices/crm/marketingSettingSlice";
import crmVote from "./slices/crm/crmVoteSlice";
import daiHoiCoDong from "./slices/crm/daiHoiCoDongSlice";
// B?o c?o thu chi
import baoCaoThuChi from "./slices/finance/baoCaoThuChiSlice";

import kiemKe from "./slices/asset/KiemKe/kiemKeSlice";
import kiemKeMember from "./slices/asset/KiemKe/kiemKeMemberSlice";
import nhaSanXuat from "./slices/asset/settings/DmNhaSanXuatTaiSanSlice";
import xuatXu from "./slices/asset/settings/XuatXuTaiSanSlice";
import huyTaiSan from "./slices/asset/huytaisan/huyTaiSanSlice";
import deNghiThanhLy from "./slices/asset/denghithanhly/deNghiThanhLySlice";

import nghiLe from "./slices/thietLapKhac/nghiLeSlice";
import phanCaTruc from "./slices/phanCaTrucSlice";
import chuyenGia from "./slices/hrm/KhamChuyenGiaSlice";
import chat from "./slices/chat/chatSlice";
import chatErpUnread from "./slices/chatErpUnreadSlice";
import kyThiSlice from "./slices/hrm/kyThiSlice";
import phieuTangGiamNhanSuSlice from "./slices/hrm/phieuTangGiamNhanSuSlice";
import thietLapNoiBo from "./slices/hrm/thietLapNoiBoSlice";
import marketingNoiBo from "./slices/hrm/marketingNoiBoSlice";
import tongHopDatLich from "./slices/tongHopDatLichSlice";
import dinhBien from "./slices/hrm/dinhBienSlice";const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    trainingCme,
    theme,
    auth,
    rating,
    report,
    department,
    category,
    employee,
    userPermit,
    role,
    favoriteMenu,
    posts,
    setting,
    ketquaCdha,
    hospitalManagement,
    doctorManagement,
    appointment,
    notification,
    ambulance,
    comment,
    bhytCategory,
    hrRecord,
    bangCong,
    dichvutainhacategory,
    dichvutainha,
    khachhang,
    sangKienYTuong,
    contractTypes,
    contractSettings,
    hrmContract,
    contract,
    tuyenDung,
    quanLyDuAn,
    congvan,
    trainingMethods,
    trainingCenters,
    trainingExpenses,
    trainingPrograms,
    trainingEmployees,
    qlCong,
    overTimes,
    signatureProcess,
    mealAllowances,
    trinhDoHocVan,
    // Bang luong
    thietlapluong,
    quanlyluong,
    bangPhuCapGiamTru,
    // Common
    documentSettings,
    attachment,
    qlNghi,
    erpNotification,
    regulationDocumentSetting,
    regulationManage,
    documentManage,
    hoSoManage,
    ksk,
    ghiNhanYeuCau,
    banHangSale,
    partners,
    deNghiChi,
    deNghiTamUng,
    phieuChiTien,
    phieuThuTien,
    chuyenNoiBo,
    deXuatThanhToan,
    chungTuNghiepVuKhac,
    financeMuaBanHang,
    dinhKhoanCategory,
    thuChiCategory,
    baoCaoSale,
    danhMucSale,
    nhapKhoSale,
    settingSale,
    thuChiSale,
    traCuuSale,
    traHangSale,
    uploadSale,
    xuatKhoSale,
    nhapXuatSale,
    thuTienSale,
    deXuatMuaSam,
    tonghopdeXuatMuaSam,
    employeeTransfer,
    salechangehistory,
    kehoachmuahang,
    chucVuCategory,
    chucDanhCategory,
    chuyenMonCategory,
    hocVanCategory,
    nhomTaiSan,
    loaiTaiSan,
    taiXe,
    taiSan,
    suaChua,
    capPhatTaiSan,
    thuHoiTaiSan,
    linhKien,
    categoryAssetSlice,
    kiemKe,
    kiemKeMember,
    baoMat,
    marketingCampaign,
    marketingSetting,
    crmExport,
    erpComment,
    erpImport,
    deNghiThuTien,
    baoCaoThuChi,
    assetDieuChuyen,
    deXuatMuaSamTS,
    viTritaiSan,
    crmVote,
    daiHoiCoDong,
    nhaSanXuat,
    xuatXu,
    huyTaiSan,
    deNghiThanhLy,
    nghiLe,
    thietLapKhac,
    phanCaTruc,
    practiveManagement,
    noidungchuyenmonthuchanhSlice,
    thietlapthuchanhSlice,
    banGiaoTaiSan,
    xinThoiViecSlice,
    historyChange,
    chuyenGia,
    chat,
    chatErpUnread,
    kyThiSlice,
    phieuTangGiamNhanSu: phieuTangGiamNhanSuSlice,
    dieuXe,
    thietLapNoiBo,
	marketingNoiBo,
    tongHopDatLich,
	dinhBien,    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
